module.exports = __webpack_public_path__ + "static/media/picture-(240).57d49041.JPG";